<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" 
          :class="[setBtnColor]"  
          :useBtnList="useBtnList"
          :unUseBtnList="unUseBtnList"
          @btnPorSheet="btnPorSheet" @btnBomList="btnBomList" @btnReceiptRequest="btnReceiptRequest" @btnPrintRequest="btnPrintRequest" 
          @btnPrintRequestVn="btnPrintRequestVn" @btnMakeBidding="btnMakeBidding" @btnRequestList="btnRequestList" @btnPipeListSaveAsExcel="btnPipeListSaveAsExcel"
          :key="useBtnListKey"
        >
          <template v-slot:body>
            <v-layout column >
              <v-row no-gutters>
                <v-col cols="12" class="pa-1">
                  <i-label :label="'Basic Information'"/>
                </v-col>
              </v-row>
              <v-row dense class="form-layout">
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters >
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-row no-gutters class="row__select-no">
                        <v-col cols="6">
                          <v-select
                            v-model="quotNo"
                            :items="quotationNoList"
                            item-value="sysCode"
                            label="Select No"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="quotNoChange"
                          ></v-select>
                        </v-col>
                        <v-col cols="6" class="pl-2 pt-1 quotNo">
                          {{quotStepGbn}}
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Title</span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field 
                        v-model="formData.title" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Ship No, POR No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.shipNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Start Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.startDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Finish Time</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.finishDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Delivery Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.delivery" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Payment Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.payment" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Purchase Charger</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.charger" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <!-- 수정 -->
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Recieve Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.recieveDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Submit Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.submitDate" 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        dense 
                        outlined 
                        hide-details="auto"
                        readonly
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="3" class="pa-1">
                  <i-label :label="'Detail Information'"/>
                </v-col>
                <v-col cols="9" align="right" class="pa-1"  :style="receiveYn != null && receiveYn === 'Y' ? 'display: none;' : '' ">
                  <span class="pa-1 subTitle2">[Not yet Received]</span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms4010" 
                    class="hipGridHeight5" 
                    :ref="epms3010Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="id" caption="No" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="shipNo" caption="Ship No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="porNo" caption="Por No" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlCd" caption="Material Code" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlSpec" caption="Material Specition" width="42%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="matlUnit" caption="Unit" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="reqQty" caption="Quantity" width="5%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="whReqDte" width="10%" data-type="string" alignment="center" header-cell-template="dateTemplate" :allow-editing="false" />
                    <template #dateTemplate>
                      <div>Request<br>Delivery Date</div>
                    </template>
                    <DxColumn data-field="certYn" width="5%" data-type="string" alignment="center" header-cell-template="certTemplate" :allow-editing="false" />
                    <template #certTemplate>
                      <div>Cert<br>Y/N</div>
                    </template>
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                  <div :style="filePath != null && filePath != '' ? '' : 'display:none;' ">
                    <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" @click="fileOpen">View Attached File</span>
                  </div>
                  <div :style="dwgCount > 0 ? '' : 'display:none;' ">
                    <v-icon color="blue">$folder</v-icon><span class="pl-1 drawing" @click="drawingPage">View Drawing Page</span>
                  </div>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
    <drawingPagePop v-if="showPop" :showPop.sync="showPop" :paramNo="quotNo" :gbn="'QUOT'" />
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import drawingPagePop from '@/views/hip/common/drawingPagePop';
import { ftpDownload} from '@/api/view/hip/common/common.js'
import { getDwgCountByQuot , getQuotNoList , getRequestHead , getRequestDetail , goReceive , reportView , getPipeQuotYn , getQuotStep} from '@/api/view/hip/common/common.js'
import { epms7010xls } from '@/api/view/hip/common/commonXls'

export default {
  name: 'epms3010',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    drawingPagePop
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      unUseBtnList: [],
      useBtnList: ['btnPorSheet', 'btnBomList', 'btnReceiptRequest', 'btnPrintRequest', 'btnPrintRequestVn', 'btnMakeBidding', 'btnRequestList' , 'btnPipeListSaveAsExcel'],
      useBtnListTemp: ['btnPorSheet', 'btnBomList', 'btnReceiptRequest', 'btnPrintRequest', 'btnPrintRequestVn', 'btnMakeBidding', 'btnRequestList' , 'btnPipeListSaveAsExcel'],
      setBtnColor: 'setBtnColor',
      formData: {
        quotNo: '' , shipNo: '', title: '', startDate: '', charger: '', finishDate: '', delivery: '' , 
        payment: '', recieveDate: '', submitDate: ''
      },
      quotationNoList: [],
      quotationNoList2: [],
      quotationNo: '',
      quotStepGbn: '',
      epms3010Ref: 'epms3010Ref',
      gridMainList: [],
      
      quotStep: '',
      quotNo: '',
      receiveYn: 'N',
      submitYn: 'N',
      filePath: '',

      showPop: false,
      sys: this.$store.state.system.sysCd,
      dwgCount: 0,
      useBtnListKey: 0,
      strPipeYn : ''
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms3010Ref)
    },
  },
  mounted() {
    if(!this.$route.params.quotNo){
      this.doSearchQuotNo()

    } else {
      this.quotNo = this.$route.params.quotNo
      this.quotStep = this.$route.params.quotStep
      this.doSearchQuotNo()
      this.doSearchMain()
    }

  },
  methods: {
    async doSearchQuotNo(){
      
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        quotStep: 'C',
        userId: this.$store.state.user.userId,
        quotDiv: '',
      }
      await getQuotNoList(params).then(res => {
        if(res.list.length){
          res.list.forEach(e => {
            this.quotationNoList.push(e.quotNo)
            if(e.quotNo == this.$route.params.quotNo){
              this.quotNo = e.quotNo
            }
          });
          this.quotationNoList2 = res.list
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    async doSearchMain () {
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
          quotStep: this.quotStep,
          quotDiv: '',
          quotNo: this.quotNo
        }
        console.log(params)
        await getRequestHead(params).then(res => {
          console.log(" RES : " , res)
          if(res.list.length){
            let list = res.list[0]
            this.formData = {
              quotNo: list.quotNo , shipNo: list.shipPorNo, title: list.quotTitle, startDate: list.startDte, charger: list.buyerName, finishDate: list.finishDte, 
              delivery: list.transCondDesc ,payment: list.payCondDesc, recieveDate: list.receiveDte, submitDate: list.submitDte
            }
            this.receiveYn = res.list[0].receiveYn
            this.submitYn = res.list[0].submitYn
            this.filePath = res.list[0].filePath
          }
          if(this.receiveYn !== 'Y') {
              this.setBtnColor = 'setBtnColor'
            } else {
              this.setBtnColor = ''
            }
        })

        await getRequestDetail(params).then(res => {
          if(res.list.length){
            this.gridMainList = res.list
          }
        })

        await getPipeQuotYn(params).then( res => {
          this.strPipeYn = res.list[0].yn
        })

        await getDwgCountByQuot(params).then( res => {
          this.dwgCount = res.list[0].tcnt
        })
        
        this.setBtnList()
      } finally {
        this.endLoading()
      }
    },
    quotNoChange(e){
      this.quotationNoList2.forEach(element => {
        if(element.quotNo == e){
          this.quotStep = element.quotStep
          if(element.quotStep === 'C2'){
            this.quotStepGbn = '1st re-Bid'
          } else if(element.quotStep === 'C3'){
            this.quotStepGbn = '2nd re-Bid'
          } else if(element.quotStep === 'C4'){
            this.quotStepGbn = '3rd re-Bid'
          } else {
            this.quotStepGbn = ''
          }
        } 
      });

      this.quotNo = e

      this.doSearchMain()
    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        if(e.column.dataField === 'matlSpec'){
          e.cellElement.style['text-align'] = 'left'
        }
      }
    },
    btnRequestList(){
      this.$router.push({name: 'epms3000' });
    },
    btnPorSheet(){
      if(this.quotNo === null && this.quotNo === ''){
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'por_sheet.jrxml',
        as_quot_no: this.quotNo,
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnBomList(){
      if(this.quotNo === null && this.quotNo === ''){
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'bom_list.jrxml',
        as_quot_no: this.quotNo,
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnReceiptRequest(){
      if(!this.receiveYn && this.receiveYn === "Y"){
        return
      }
      if(!this.quotNo){
        this.vToastify(this.$t('There is no data for receive the Bidding Request.'), 'warn')
        return
      }
      let params = {
        quotNo: this.quotNo,
        makerCd: this.$store.state.user.makerCd,
        quotStep: this.quotStep
      }
      this.vToastifyPrompt(
        this.$t('Do you want to receive the bidding Request?'),
        'info',
          current => {
          this.openLoading('searching')
          goReceive(params)
            .then(res => {
              const msg = res.body
              if(msg === 'OK') {
                notify(this.$t('Receipt Bid Quotation is completed.'), 'success', 3000)
                this.doSearchMain()
              } else {
                this.vToastify(this.$t(msg), 'warn')
              }
            })
            .catch(error => {
              this.vToastify(error, 'warn')
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
          },
        null,
        true
      )
    },
    btnPrintRequest(){
      if(this.quotNo === null && this.quotNo === ''){
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'epms3010.jrxml',
        as_quot_no: this.quotNo,
        as_maker_cd: this.$store.state.user.makerCd
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnPrintRequestVn(){
      if(this.quotNo === null && this.quotNo === ''){
        this.vToastify(this.$t('There is no information for print.'), 'warn')
        return
      }
      const param = {
        fileName: 'epms3010vn.jrxml',
        as_quot_no: this.quotNo,
        as_maker_cd: this.$store.state.user.makerCd
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnMakeBidding(){
      if(!this.quotNo){
        this.vToastify(this.$t('There is no data for make quotation.'), 'warn')
        return
      }
      if(this.receiveYn != null && this.receiveYn !== 'Y'){
        this.vToastify(this.$t('Not yet Received'), 'warn')
        return
      }

      let div = this.quotNo.substring(1,2) 

      if (div === 'L') {
        this.$router.push({ name: 'epms3030', params: {quotNo: this.quotNo, receiveYn: this.receiveYn, quotStep: this.quotStep } });
      } else if (div === 'O') {
        this.$router.push({ name: 'epms3040', params: {quotNo: this.quotNo, receiveYn: this.receiveYn, quotStep: this.quotStep } });
      } else if (this.quotNo.includes('WM')) {
        this.$router.push({ name: 'epms3020_waste', params: {quotNo: this.quotNo, receiveYn: this.receiveYn, quotStep: this.quotStep } });
      } else {
        this.$router.push({ name: 'epms3020', params: {quotNo: this.quotNo, receiveYn: this.receiveYn, quotStep: this.quotStep } });
      }
      //this.$router.push({name: 'epms3020' , params: {quotNo: this.quotNo, receiveYn: this.receiveYn, quotStep: this.quotStep }});
    },
    drawingPage(){
      this.showPop = true
    },
    btnPipeListSaveAsExcel(){
      if(!this.quotNo && this.quotNo === ''){
        this.vToastify(this.$t('Quotation number is not selected.'), 'warn')
        return
      }

      const param = {
        quotNo: this.quotNo,
        makerCd: this.$store.state.user.makerCd,
        quotStep: this.quotStep
      }
      epms7010xls(param)

    },
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)

      if(this.receiveYn === 'Y') {
        this.unUseBtnList.push('btnReceiptRequest')
      }

      if(this.pipeYn !== 'Y') {
        btnTemp = this.$_.filter(btnTemp, function(btnTemp) {
          return btnTemp !== 'btnPipeListSaveAsExcel'
        })
      }

      this.useBtnList = btnTemp
      this.useBtnListKey++
    },
    fileOpen(e){
      let file = this.filePath
      this.openLoading('searching')
      ftpDownload(file)
      .finally(() => {
        this.endLoading()
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.form-layout::v-deep .col {
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: gray;
  
  * {
    border: 0px none !important;
  }

  .row:not(.row__select-no) {
    border-width: 0 0 1px 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }

  .col:not(.quotNo) {
    border-width: 0 1px 0 0 !important;
    border-style: solid !important;
    border-color: gray !important;
  }
}
.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: black;
  font-size: 9pt;
}
.subTitle {
  font-weight: bold;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
.quotNo {
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: #0000FF;
  font-size: 9pt;
}
.drawing {
  font-size: 10pt;
  color: black;
  cursor: pointer;
}
.drawing:hover{
  color: #4980BC;
}
$redBtn: #FF0000;
$blueBtn: #0000FF;
.setBtnColor::v-deep {
  [role=btnReceiptRequest]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
  [role=btnPrintRequest], [role=btnPrintRequestVn] {
    .v-btn__content {
      div, i {
        color: #{$blueBtn} !important;
      }
    }
  }

}
</style>